import Axios from 'core/axios';
import Validation from 'core/validation';
import Rest from 'core/rest';
export const SAMPLE_SEARCH_SUCCESS = 'SAMPLE_SEARCH_SUCCESS';
export const SAMPLE_SEARCH_SUCCESS_ERRORS = 'SAMPLE_SEARCH_SUCCESS_ERRORS';

export const search = (data)=>{
	return (dispatch) => {
		const errors = Validation.sampleSearch(data);//欄位驗證
		
		if(Object.keys(errors).length > 0){
			dispatch({
				type: SAMPLE_SEARCH_SUCCESS_ERRORS,
				errors
			});
		}else{
			Axios.post(Rest.search(), data)
				.then((response)=>{
					dispatch({
						type: SAMPLE_SEARCH_SUCCESS,
						data: response
					});
				})
				.catch((error)=>{
					alert('error: ' + JSON.stringify(error));
				});
		}
		
		

	};
};